import Activity from "../../modules/header/activity-client-vanilla";
import { isNNDomain } from "../../utils/window";

if (!isNNDomain()) {
  Activity.init();
}
